import classNames from 'classnames';
import MailInboxIcon from 'Components/common/assets/svgIcons/MailInboxIcon';
import React from 'react';
import styled from 'styled-components';
import {
  primaryColor, secondaryFont, primaryHeadingColor, maxWidth, retina, maxTablet,
  wMBold,
} from 'Utils/utilsStyle';

// Hoisted so the default prop keeps a stable identity across renders.
const mailInboxIcon = <MailInboxIcon color={primaryColor} />;

type Props = {
  title?: string,
  icon?: React.ReactNode,
  onClick?: () => void,
} & typeof defaultProps;

const defaultProps = {
  title: 'Drop people here to create a new group…',
  icon: mailInboxIcon,
  onClick: undefined as (() => void) | undefined,
};

const Wrapper = styled.div`
  background: linear-gradient(180deg, rgba(30, 194, 82, 0.188608) 0%, rgba(30, 194, 82, 0.0442275) 100%);
  border: 2px dashed #1EC252;
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  width: 100%;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 14px 20px;
    border-radius: 7px;
    margin-bottom: 15px;
  }
  .title {
    color: ${primaryHeadingColor};
    font-family: ${secondaryFont};
    font-size: 18px;
    line-height: 20px;
    font-weight: ${wMBold};
    margin-left: 16px;
    margin-right: 40px;
    letter-spacing:-0.45px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 16px;
      line-height: 20px;
      margin-left: 14px;
    }
     @media all and (max-width: ${maxTablet}) {
      width: calc(100% - 50px);
    }
  }
  &.clickable {
    cursor: pointer;
  }
  svg {
    width: 44px;
    height: 48px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      height: 45px;
      width: auto;
    }
    @media all and (max-width: ${maxTablet}) {
      width: 45px;
    }
  }
`;

const DropHereToCreateGroup = function DropHereToCreateGroup(props: Props) {
  const { title, icon, onClick } = props;
  return (
    <Wrapper
      className={classNames('drop-placement', { clickable: onClick })}
      onClick={onClick}
      onKeyPress={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {icon}
      <span className="title">{title}</span>
    </Wrapper>
  );
};

DropHereToCreateGroup.defaultProps = defaultProps;
export default DropHereToCreateGroup;
